

















































import CollectionSharedFunctions from '@/views/app/management/collections/CollectionSharedFunctions'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import ScrollView from '@/components/ScrollView.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import Icon from '@/components/Icon.vue'
import { ECollectionHistoryType, ICollectionHistory, IResidentEventHistoryFiltersDTO } from '@zunta/configurations'
import Modal from '@/components/Modal.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import EditHistoryCommentModal from '@/components/modals/EditHistoryCommentModal.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import Table from '@/components/tables/Table.vue'

@Component({
  components: {
    Table,
    EditHistoryCommentModal,
    TextArea,
    Modal,
    Icon,
    DateTimeLabel,
    ScrollView,
    SearchInput,
    DateInput
  }
})
export default class CollectionHistoryTable extends CollectionSharedFunctions {
  selectedHistoryItem: Partial<ICollectionHistory> | null = {
    note: ''
  }

  filters: IResidentEventHistoryFiltersDTO = {
    type: ECollectionHistoryType.COLLECTION
  }

  showHistoryModal: boolean = false

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: false,
    usePagination: false,
    fetchFunction: this.fetchResidentHistory,
    maxHeight: '300px',
    columns: [
      {
        minWidth: '350px',
        width: 45,
        key: 'event',
        searchKey: 'event',
        hasSearch: true,
        label: 'Event',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 15,
        key: 'eventType',
        searchKey: 'eventType',
        hasSearch: true,
        label: 'Event Type',
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 20,
        key: 'date',
        searchKey: 'date',
        hasSearch: true,
        label: 'Date',
        type: ETableColumnType.date
      },
      {
        minWidth: '150px',
        width: 15,
        key: 'user',
        searchKey: 'user',
        hasSearch: true,
        label: 'User',
        type: ETableColumnType.default
      },
      {
        minWidth: '50px',
        width: 5,
        key: 'actions',
        hasSearch: false
      }
    ]
  }

  async fetchResidentHistory (filters: any) {
    await this.residentModuleInstance.fetchResidentHistoryByFilters({
      filters,
      residentId: this.residentId
    })
  }

  mounted () {
    // @ts-ignore
    this.$eventBus.$on('CollectionView:loadHistory', this.$refs.table.initSearch)
    this.$watch('collectionsHistory', this.scrollToBottomOfTheHistory, { immediate: true })
  }

  beforeDestroy () {
    this.$eventBus.$off('CollectionView:loadHistory')
  }

  openNoteModal (item: Partial<ICollectionHistory>) {
    this.selectedHistoryItem = { ...item }
    this.showHistoryModal = true
  }

  closeNoteModal () {
    this.selectedHistoryItem = {
      note: null
    }
    this.showHistoryModal = false
  }

  scrollToBottomOfTheHistory () {
    this.$nextTick(() => {
      const el = document.querySelector('#collection-history .scroll-area')
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    })
  }
}
